var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "renwulist" }, [
    _c(
      "div",
      { staticClass: "tabs" },
      _vm._l(_vm.tabList, function (item) {
        return _c(
          "div",
          {
            class: ["tab", { select: item.id == _vm.tab.id }],
            on: {
              click: function ($event) {
                return _vm.selectTab(item)
              },
            },
          },
          [_vm._v("\n      " + _vm._s(item.text) + "\n    ")]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "search-wrapper" }, [
      _c("div", { staticClass: "item" }, [
        _c("span", { staticClass: "lable" }, [_vm._v("打卡状态:")]),
        _vm._v(" "),
        _c("div", { staticClass: "scroll-wrapper" }, [
          _c(
            "div",
            {
              staticClass: "scroll",
              style: { width: 1.7 * _vm.dakaList.length + "rem" },
            },
            _vm._l(_vm.dakaList, function (item) {
              return _c(
                "span",
                {
                  class: ["radio", { check: _vm.dakaStatus.id == item.id }],
                  on: {
                    click: function ($event) {
                      return _vm.selectRadio("dakaStatus", item)
                    },
                  },
                },
                [_vm._v(_vm._s(item.text))]
              )
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item" }, [
        _c("span", { staticClass: "lable" }, [_vm._v("客户状态:")]),
        _vm._v(" "),
        _c("div", { staticClass: "scroll-wrapper" }, [
          _c(
            "div",
            {
              staticClass: "scroll",
              style: { width: 1.7 * _vm.kehuStatusList.length + "rem" },
            },
            _vm._l(_vm.kehuStatusList, function (item) {
              return _c(
                "span",
                {
                  class: ["radio", { check: _vm.kehuStatus.id == item.id }],
                  on: {
                    click: function ($event) {
                      return _vm.selectRadio("kehuStatus", item)
                    },
                  },
                },
                [_vm._v(_vm._s(item.text))]
              )
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.tab.id == "my"
        ? _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "lable" }, [_vm._v("类型:")]),
            _vm._v(" "),
            _c("div", { staticClass: "scroll-wrapper" }, [
              _c(
                "div",
                {
                  staticClass: "scroll",
                  style: { width: 1.7 * _vm.typeList.length + "rem" },
                },
                _vm._l(_vm.typeList, function (item) {
                  return _c(
                    "span",
                    {
                      class: ["radio", { check: _vm.type.id == item.id }],
                      on: {
                        click: function ($event) {
                          return _vm.selectRadio("type", item)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.text))]
                  )
                }),
                0
              ),
            ]),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "list" },
      [
        _vm._l(_vm.list, function (item) {
          return _c("div", { key: item.id, staticClass: "item" }, [
            _c("div", { staticClass: "body" }, [
              item.khtx
                ? _c("img", {
                    staticClass: "avater",
                    attrs: { src: item.khtx },
                  })
                : _c("img", {
                    staticClass: "avater",
                    attrs: { src: require("../../images/avater_default.png") },
                  }),
              _vm._v(" "),
              _c("div", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm._f("khxmFilter")(item.khxm, item))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "time" }, [_vm._v(_vm._s(item.rwsj))]),
              _vm._v(" "),
              _c("div", { staticClass: "phone" }, [_vm._v(_vm._s(item.khdh))]),
              _vm._v(" "),
              item.timeDownStr && item.timeDownStr != "已超时"
                ? _c("div", { staticClass: "time" }, [
                    _vm._v("打卡倒计时：" + _vm._s(item.timeDownStr)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.tab.id == "my" && item.zxr_list.length > 0
                ? _c("div", { staticClass: "zxr" }, [
                    _vm._v("打卡人:" + _vm._s(item.zxr_list[0].login_name)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "status" }, [
                _vm._v(
                  _vm._s(item.timeDownStr == "已超时" ? "已完成" : item.dkzt) +
                    " | " +
                    _vm._s(item.khzt)
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "footer" }, [
              _c(
                "div",
                {
                  staticClass: "btn wran",
                  on: {
                    click: function ($event) {
                      return _vm.handleItemEvent("delete", item)
                    },
                  },
                },
                [_vm._v("删除")]
              ),
              _vm._v(" "),
              _vm.tab.id == "my"
                ? _c(
                    "div",
                    {
                      staticClass: "btn",
                      on: {
                        click: function ($event) {
                          return _vm.handleItemEvent("tiwo", item)
                        },
                      },
                    },
                    [_vm._v("替我打卡")]
                  )
                : _vm._e(),
              _vm._v(" "),
              item.timeDownStr != "已超时"
                ? _c(
                    "div",
                    {
                      staticClass: "btn",
                      on: {
                        click: function ($event) {
                          return _vm.handleItemEvent("daka", item)
                        },
                      },
                    },
                    [_vm._v("带看打卡")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "btn",
                  on: {
                    click: function ($event) {
                      return _vm.handleItemEvent("addJiHua", item)
                    },
                  },
                },
                [_vm._v("添加计划")]
              ),
              _vm._v(" "),
              _vm.tab.id == "my"
                ? _c(
                    "div",
                    {
                      staticClass: "btn",
                      on: {
                        click: function ($event) {
                          return _vm.handleItemEvent("edit", item)
                        },
                      },
                    },
                    [_vm._v("编辑客户")]
                  )
                : _vm._e(),
            ]),
          ])
        }),
        _vm._v(" "),
        _vm.hasMore
          ? _c("div", { staticClass: "next", on: { click: _vm.nextPage } }, [
              _vm._v("下一页"),
            ])
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _vm.list.length == 0
      ? _c("div", { staticClass: "list-null" }, [_vm._v(" 暂无数据 ")])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }